export default __webpack_public_path__ + "static/media/inventory_tier_icon.1615ffa3.svg";